/** Keep only the room overlay inside the area above the mobile keyboard/browser bars. */
export function bindRoomViewport(overlay: HTMLElement, hostWindow: Window = window): () => void {
  const viewport = hostWindow.visualViewport;
  let previousHeight = 0;
  const update = (): void => {
    const height = viewport && Number.isFinite(viewport.height) && viewport.height > 0
      ? viewport.height
      : hostWindow.innerHeight;
    const top = viewport && Number.isFinite(viewport.offsetTop) ? Math.max(0, viewport.offsetTop) : 0;
    if (!Number.isFinite(height) || height <= 0) return;
    overlay.style.setProperty("--fp-room-viewport-height", `${height}px`);
    overlay.style.setProperty("--fp-room-viewport-top", `${top}px`);
    // Run only on shrink, not scroll: the user must still be able to scroll away
    // from a focused field. Keep the input above the pinned actions when the keyboard opens.
    if (height < previousHeight) {
      const active = overlay.ownerDocument?.activeElement;
      const fields = active?.closest<HTMLElement>(".fp-room-fields");
      if (active && fields && overlay.contains(fields)) {
        const inputRect = active.getBoundingClientRect();
        const fieldsRect = fields.getBoundingClientRect();
        if (inputRect.bottom > fieldsRect.bottom - 12) fields.scrollTop += inputRect.bottom - fieldsRect.bottom + 12;
        else if (inputRect.top < fieldsRect.top + 12) fields.scrollTop += inputRect.top - fieldsRect.top - 12;
      }
    }
    previousHeight = height;
  };
  update();
  viewport?.addEventListener("resize", update);
  viewport?.addEventListener("scroll", update);
  hostWindow.addEventListener("resize", update);
  return () => {
    viewport?.removeEventListener("resize", update);
    viewport?.removeEventListener("scroll", update);
    hostWindow.removeEventListener("resize", update);
    overlay.style.removeProperty("--fp-room-viewport-height");
    overlay.style.removeProperty("--fp-room-viewport-top");
  };
}
